import { ICellEditorParams } from 'ag-grid-community';

/** Custom cell editor to handle Shift + Return for line breaks
*/ 
class CustomTextAreaEditor {
  private eInput: HTMLTextAreaElement; // Explicitly define the type for eInput
  private onKeyDown = (event: KeyboardEvent) => { // Define onKeyDown method
    if (event.key === 'Enter' && event.shiftKey) {
      event.stopPropagation(); // Prevent ag-grid from closing the editor
    }
  };

  constructor() {
    this.eInput = document.createElement('textarea');
    this.eInput.style.width = '100%';
    this.eInput.style.height = '100%';
  }

  init(params: ICellEditorParams): void { // Type params as ICellEditorParams
    // Convert \n strings back to actual line breaks for editing
    const value = params.value || '';
    const convertedValue = typeof value === 'string' ? value.replace(/\\n/g, '\n') : value;
    this.eInput.value = convertedValue;
    
    this.eInput.addEventListener('keydown', (event: KeyboardEvent) => { // Type event as KeyboardEvent
      if (event.key === 'Enter' && event.shiftKey) {
        event.stopPropagation(); // Prevent ag-grid from closing the editor
      }
    });
  }

  getGui(): HTMLElement {
    return this.eInput;
  }

  afterGuiAttached(): void {
    this.eInput.focus();
  }

  getValue(): string {
    return this.eInput.value;
  }

  destroy(): void {
    this.eInput.removeEventListener('keydown', this.onKeyDown); // Ensure onKeyDown is typed
  }

  isPopup(): boolean {
    return false;
  }
}

export default CustomTextAreaEditor;